import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import Markdown from 'preact-markdown';
import util from 'preact-util';

import GuiListFrontpage from '../../components/gui/listFrontpage';

const ICON_SIZE = '35px';

const MARKDOWN_OPTIONS = {
    pedantic: false,
    gfm: true,
    breaks: true,
    sanitize: false,
    smartLists: true,
    smartypants: true,
    xhtml: true,
highlight: function(code, lang) {
    const hljs = require('highlight.js');
    const language = hljs.getLanguage(lang) ? lang : 'plaintext';
    return hljs.highlight(code, { language }).value;
  },
langPrefix: 'hljs language-', // highlight.js css expects a top-level 'hljs' class.
};

@observer
class FFEProducts extends Component {
    constructor(props) {
        super(props);
        this.imageIdRefs = {};
    }

    loadAll = async () => {
        const { ffeStore } = this.props.stores;
        const { search, brand, mainCategory, intermediateCategory, subCategory } = ffeStore;

        await Promise.all([
            ffeStore.getBrands(),
            ffeStore.getCategories({ brand }),
            ffeStore.getProducts({ mainCat: mainCategory, brand, search }),
            // ffeStore.getConsumerProducts({ mainCat: mainCategory, brand, search }),
            // ffeStore.getDealers()
        ]);
    }

    loadMore = async () => {
        const { ffeStore } = this.props.stores;
        const { productLimit, productOffset, productTotal } = ffeStore;
        let newOffset = productOffset + productLimit;
        if (newOffset >= productTotal) {
            newOffset = productTotal;
        }
        // console.log('loadMore', { limit, offset, productTotal, newOffset });
        ffeStore.updateKeyValue('productOffset', newOffset);
        this.ffeGetProducts({ append: true });
    }

    setLoadMore = () => {
        const { ffeStore } = this.props.stores;
        ffeStore.setLoadMore(() => {
            clearTimeout(this.reloadTimer);
            const { productLimit, productOffset, productTotal } = ffeStore;
            let newOffset = productOffset + productLimit;
            if (newOffset >= productTotal) {
                newOffset = productTotal;
            }
            console.log('load more', { productLimit, productOffset, productTotal, newOffset });
            ffeStore.updateKeyValue('productOffset', newOffset);
            this.loadMore();
        });

        ffeStore.setRefreshPage(() => {
            clearTimeout(this.reloadTimer);
            const { productLimit, productOffset, productTotal } = ffeStore;
            let newOffset = 0;
            ffeStore.updateKeyValue('productOffset', newOffset);
            this.loadAll(this.props, false, false);
        });
    }

    unsetLoadMore = () => {
        const { ffeStore } = this.props.stores;
        ffeStore.setLoadMore(() => {});
        ffeStore.setRefreshPage(() => {});
    }


    ffeGetBrands = async () => {
        const { ffeStore } = this.props.stores;
        const response = await ffeStore.getBrands();
        console.log('ffeGetBrands', response);
        this.ffeGetCategories();
        this.ffeGetProducts({ append: false });
        // this.ffeGetConsumerProducts();
    }
    ffeGetCategories = async () => {
        const { ffeStore } = this.props.stores;
        const { search, brand, mainCategory, intermediateCategory, subCategory } = ffeStore;
        const response = await ffeStore.getCategories({ brand });
        console.log('ffeGetCategories', response);

    }
    ffeGetProducts = async ({ append = false, offset }) => {
        const { ffeStore } = this.props.stores;
        const { search, brand, mainCategory, intermediateCategory, subCategory } = ffeStore;
        const response = await ffeStore.getProducts({
            offset,
            append,
            mainCat: mainCategory,
            brand,
            search,
        });
        console.log('ffeGetProducts', response);
    }
    ffeGetConsumerProducts = async () => {
        const { ffeStore } = this.props.stores;
        const { search, brand, mainCategory, intermediateCategory, subCategory } = ffeStore;
        const response = await ffeStore.getConsumerProducts({
            mainCat: mainCategory,
            brand,
            search,
        });
        console.log('ffeGetConsumerProducts', response);
    }
    // ffeGetDealers = async () => {
    //     const { ffeStore } = this.props.stores;
    //     const response = await ffeStore.getDealers();
    //     console.log('ffeGetDealers', response);
    // }

    chooseBrand = e => {
        e.stopPropagation();
        e.preventDefault();
        const { brand } = e.target.closest('div').dataset;
        const { ffeStore } = this.props.stores;
        ffeStore.updateKeyValue('brand', brand);
        ffeStore.updateKeyValue('mainCategory', undefined);
        ffeStore.updateKeyValue('intermediateCategory', undefined);
        ffeStore.updateKeyValue('subCategory', undefined);
        ffeStore.updateKeyValue('products', []);
        ffeStore.updateKeyValue('categories', []);
        ffeStore.updateKeyValue('productOffset', 0);
        this.loadAll();
    }

    chooseMainCategory = e => {
        e.stopPropagation();
        e.preventDefault();
        const { category } = e.target.closest('div').dataset;
        const { ffeStore } = this.props.stores;
        ffeStore.updateKeyValue('products', []);
        ffeStore.updateKeyValue('productOffset', 0);
        ffeStore.updateKeyValue('mainCategory', parseInt(category, 10));
        // this.ffeGetConsumerProducts();
        this.ffeGetProducts({ append: false });
    }

    getImageScrollerRef = (ref, id) => {
        // console.log('getImageScrollerRef', ref, id);
        this.imageIdRefs[id] = ref;
    }

    scrollToImage = (id, imageIdx) => {
        const el = this.imageIdRefs[id];
        if (!el) return;

        const targetX = el.clientWidth * imageIdx;
        const deltaX = targetX - el.scrollLeft;

        setTimeout(() => {
            el.scrollBy({
                top: 0,
                left: deltaX,
                behavior: 'smooth'
            });
        }, 200);
    }

    onOption1Change = (e, id, optionName) => {
        const { value } = e.target;
        // console.log('onOption1Change', e, id, optionName, value);
        const { ffeStore } = this.props.stores;
        const { products } = ffeStore;
        const product = products.find(p => p.id === id);
        if (product) {
            if (product.images) {
                const image = product.images.find(img => img.option_1 === value && (product.selectedOption2 ? img.option_2 === product.selectedOption2 : true) && (product.selectedOption3 ? img.option_3 === product.selectedOption3 : true));
                const imageIdx = product.images.indexOf(image);
                // console.log('found image', image, imageIdx);
                if (imageIdx >= 0) {
                    this.scrollToImage(id, imageIdx);
                }
                if (image) {
                    ffeStore.updateFieldByName({ namePlural: 'products', name: 'product', id, field: 'priceNOK', value: image.priceNOK, findBy: 'id' });
                    ffeStore.updateFieldByName({ namePlural: 'products', name: 'product', id, field: 'priceSEK', value: image.priceSEK, findBy: 'id' });
                    ffeStore.updateFieldByName({ namePlural: 'products', name: 'product', id, field: 'priceDKK', value: image.priceDKK, findBy: 'id' });
                    ffeStore.updateFieldByName({ namePlural: 'products', name: 'product', id, field: 'priceGBP', value: image.priceGBP, findBy: 'id' });
                    ffeStore.updateFieldByName({ namePlural: 'products', name: 'product', id, field: 'priceEUR', value: image.priceEUR, findBy: 'id' });
                    ffeStore.updateFieldByName({ namePlural: 'products', name: 'product', id, field: 'priceCHF', value: image.priceCHF, findBy: 'id' });
                    ffeStore.updateFieldByName({ namePlural: 'products', name: 'product', id, field: 'selectedOption1', value, findBy: 'id' });
                }
            }
        }
    }
    onOption2Change = (e, id, optionName) => {
        const { value } = e.target;
        // console.log('onOption2Change', e, id, optionName, value);
        const { ffeStore } = this.props.stores;
        const { products } = ffeStore;
        const product = products.find(p => p.id === id);
        if (product) {
            if (product.images) {
                const image = product.images.find(img => img.option_2 === value && (product.selectedOption1 ? img.option_1 === product.selectedOption1 : true) && (product.selectedOption3 ? img.option_3 === product.selectedOption3 : true));
                const imageIdx = product.images.indexOf(image);
                // console.log('found image', image, imageIdx);
                if (imageIdx >= 0) {
                    this.scrollToImage(id, imageIdx);
                }
                if (image) {
                    ffeStore.updateFieldByName({ namePlural: 'products', name: 'product', id, field: 'priceNOK', value: image.priceNOK, findBy: 'id' });
                    ffeStore.updateFieldByName({ namePlural: 'products', name: 'product', id, field: 'priceSEK', value: image.priceSEK, findBy: 'id' });
                    ffeStore.updateFieldByName({ namePlural: 'products', name: 'product', id, field: 'priceDKK', value: image.priceDKK, findBy: 'id' });
                    ffeStore.updateFieldByName({ namePlural: 'products', name: 'product', id, field: 'priceGBP', value: image.priceGBP, findBy: 'id' });
                    ffeStore.updateFieldByName({ namePlural: 'products', name: 'product', id, field: 'priceEUR', value: image.priceEUR, findBy: 'id' });
                    ffeStore.updateFieldByName({ namePlural: 'products', name: 'product', id, field: 'priceCHF', value: image.priceCHF, findBy: 'id' });
                    ffeStore.updateFieldByName({ namePlural: 'products', name: 'product', id, field: 'selectedOption2', value, findBy: 'id' });
                }
            }
        }
    }
    onOption3Change = (e, id, optionName) => {
        const { value } = e.target;
        // console.log('onOption3Change', e, id, optionName, value);
        const { ffeStore } = this.props.stores;
        const { products } = ffeStore;
        const product = products.find(p => p.id === id);
        if (product) {
            if (product.images) {
                const image = product.images.find(img => img.option_3 === value && (product.selectedOption1 ? img.option_1 === product.selectedOption1 : true) && (product.selectedOption2 ? img.option_2 === product.selectedOption2 : true));
                const imageIdx = product.images.indexOf(image);
                // console.log('found image', image, imageIdx);
                if (imageIdx >= 0) {
                    this.scrollToImage(id, imageIdx);
                }
                if (image) {
                    // +                    priceNOK: 1,
                    // +                    priceSEK: 1,
                    // +                    priceDKK: 1,
                    // +                    priceGBP: 1,
                    // +                    priceEUR: 1,
                    // +                    priceCHF: 1,
                    ffeStore.updateFieldByName({ namePlural: 'products', name: 'product', id, field: 'priceNOK', value: image.priceNOK, findBy: 'id' });
                    ffeStore.updateFieldByName({ namePlural: 'products', name: 'product', id, field: 'priceSEK', value: image.priceSEK, findBy: 'id' });
                    ffeStore.updateFieldByName({ namePlural: 'products', name: 'product', id, field: 'priceDKK', value: image.priceDKK, findBy: 'id' });
                    ffeStore.updateFieldByName({ namePlural: 'products', name: 'product', id, field: 'priceGBP', value: image.priceGBP, findBy: 'id' });
                    ffeStore.updateFieldByName({ namePlural: 'products', name: 'product', id, field: 'priceEUR', value: image.priceEUR, findBy: 'id' });
                    ffeStore.updateFieldByName({ namePlural: 'products', name: 'product', id, field: 'priceCHF', value: image.priceCHF, findBy: 'id' });
                    ffeStore.updateFieldByName({ namePlural: 'products', name: 'product', id, field: 'selectedOption3', value, findBy: 'id' });
                }
            }
        }
    }

    componentDidMount() {
        this.loadAll();
        this.setLoadMore();
    }

    componentWillUnmount() {
        this.unsetLoadMore();
    }

    render() {
        const { ffeStore, userStore } = this.props.stores;
        const { isAdmin } = userStore;
        const {
            brands,
            categories,
            products,
            dealers,
            search,
            brand,
            mainCategory,
            intermediateCategory,
            subCategory,
            tag,
            productTotal,
            productOffset,
            productLimit,
        } = ffeStore;
        const {
            classNames,
            showTitle = true,
            showBylineHeader = false,
            showComments = false,
            showLikes = false,
            help,
            children,
            maxHeight = '90vh',
            imageStyles = '',
            fullWidthOnly = true,
            checkContentHeight = false,
            showFiles = true,
        } = this.props;
        return (<div class='w-100 d-flex justify-content-center position-relative'>
            <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>

                {/* search: {search}<br /> */}
                {/* brand: {brand}<br /> */}
                {/* main category: {mainCategory}<br /> */}
                {/* intermediate category: {intermediateCategory}<br /> */}
                {/* sub category: {subCategory}<br /> */}
                {/* productOffset: {productOffset}<br /> */}
                {/* productLimit: {productLimit}<br /> */}
                {/* productTotal: {productTotal}<br /> */}

                <div class='d-flex flex-column'>
                    <div class='d-flex flex-row overflow-auto no-scrollbar'>
                        {brands.length > 0 && <>
                            {brands.map(b => (
                                <div
                                    class={`me-3 mb-2 p-2 border rounded-lg ${b.brandno === brand ? 'bg-primary text-white' : ''}`}
                                    key={b.id}
                                    data-brand={b.brandno}
                                    onClick={this.chooseBrand}
                                >
                                    <nobr>{b.name} ({b.count})</nobr>
                                </div>
                            ))}
                        </>}
                    </div>
                    <div class='d-flex flex-row overflow-auto no-scrollbar'>
                        {categories.length > 0 && <>
                            {categories.map(category => (
                                <div
                                    class={`me-3 mb-2 p-2 border rounded-lg ${category.categoryno === mainCategory ? 'bg-primary text-white' : ''}`}
                                    key={category.id}
                                    data-category={category.categoryno}
                                    onClick={this.chooseMainCategory}
                                >
                                    <nobr>{category.name} ({category.count})</nobr>
                                </div>
                            ))}
                        </>}
                    </div>
                    {/* <div class='d-flex flex-column'>
                        {products.length > 0 && (
                            <div>
                                <h2>Products</h2>
                                <ul>
                                    {products.map(product => (
                                        <li key={product.id}>{product.name}</li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div> */}
                </div>




                <div class='d-flex flex-column w-100 position-relative'>
                    <GuiListFrontpage
                        key={`article-list-large-${brand}-${mainCategory}`}
                        styles={isAdmin ? 'border: 0.5px #a0a0a0 dotted;' : ''}
                        classNames={classNames}
                        // category={category}
                        stores={this.props.stores}
                        holdingStore={ffeStore}
                        view={this.viewArticle}
                        title={false}
                        showPadding={false}
                        list={products}
                        // list={[]}
                        elHeader={e => e.heading ? <>
                            <span
                                class='mb-0 mt-0 py-1 px-3'
                                style={`font-size: clamp(0.7rem, 2vw, 1.2rem); font-weight: 600; line-height: 1.2em; text-transform: uppercase;`}
                            >
                                {e.headingIcon ? <i class={`${e.headingIcon} me-2`} /> : ''}
                                {e.heading}
                            </span>
                        </> : <></>}
                        elTitle={e => showTitle ? <>
                            <h3 class='mb-0 mt-2 py-0'>{e.nameDisplay}</h3>
                        </> : ''}
                        elTitleRight={e => e.category === 'marketplace' ? <>
                            {e.isSold && <>
                                <span class='badge text-bg-danger ms-2'>
                                    <i class='fa-duotone fa-tag' /> <Text id='article.sold'>Sold</Text>
                                </span>
                            </>}
                            <span class='badge text-bg-success ms-2'>
                                Kr. {util.format(e.price, 2)}
                            </span>
                        </> : <></>}
                        elLink={e => `/article/${encodeURIComponent(e.title).toLocaleLowerCase()}/${e.uuidv4}`}
                        elDescription={e => <>
                            {/* {e.ingress && <div class='mt-2'><Markdown markdown={localUtil.replaceInlineContent(e.ingress)} markedOpts={MARKDOWN_OPTIONS} /></div>} */}
                            {e.priceNOK && <div>Price: Kr. {util.format(e.priceNOK, 2)}</div>}
                            <div class='form-inline'>
                            {e.option_1_name &&<select
                                class='form-control me-2'
                                onInput={event => this.onOption1Change(event, e.id, e.option_1_name)}
                            >
                                <option>Choose {e.option_1_name}</option>
                                {e.option_1.map((opt, idx) => (<option key={idx} value={opt}>{opt}</option>))}
                            </select>}
                            {e.option_2_name &&<select
                                class='form-control me-2'
                                onInput={event => this.onOption2Change(event, e.id, e.option_2_name)}
                            >
                                <option>Choose {e.option_2_name}</option>
                                {e.option_2.map((opt, idx) => (<option key={idx} value={opt}>{opt}</option>))}
                            </select>}
                            {e.option_3_name &&<select
                                class='form-control me-2'
                                onInput={event => this.onOption3Change(event, e.id, e.option_3_name)}
                            >
                                <option>Choose {e.option_3_name}</option>
                                {e.option_3.map((opt, idx) => (<option key={idx} value={opt}>{opt}</option>))}
                            </select>}
                            </div>
                            {/* <button class='btn btn-primary mt-2' onClick={() => this.scrollToImage(e.id, 3)}>View image 3</button> */}
                            {e.description && <div class='mt-2'><Markdown markdown={e.description} markedOpts={MARKDOWN_OPTIONS} /></div>}
                            {e.tech && <>
                                <h5 class='mt-3 mb-0'>Technical details</h5>
                                <div class='mt-0'><Markdown markdown={e.tech} markedOpts={MARKDOWN_OPTIONS} /></div>
                            </>}
                            {/* {e.body && <div class='font-weight-normal mt-3 mb-2'><Markdown markdown={e.body} markedOpts={MARKDOWN_OPTIONS} /></div>} */}
                        </>}
                        getImageScrollerRef={this.getImageScrollerRef}
                        // elInfo1={e => util.formatDate(e.publishDate, { hour12: false, hour: '2-digit', minute: '2-digit', locale: 'nb-NO' })}
                        // elInfo2={e => showAuthor ? e.creator : ''}
                        elInfo3={e => ''}
                        showBylineHeader={showBylineHeader}
                        showComments={showComments}
                        showLikes={showLikes}
                        elBylineHeader={e => <>
                            <div class='d-flex flex-row align-items-center justify-content-start flex-fill py-2 px-2 border-bottom'>
                                <span class='d-flex justify-content-center align-items-center rounded-circle bg-light text-dark me-2 border' style={`width: ${ICON_SIZE}; height: ${ICON_SIZE};`}>
                                    {e.creatorImage ? <>
                                        <img src={e.creatorImage} class='rounded-circle' style={`width: ${ICON_SIZE}; height: ${ICON_SIZE};`} />
                                    </> : <>
                                        <i class='fa-duotone fa-user' style='font-size: 1.5rem; line-height: 1.5rem;' />
                                    </>}
                                </span>
                                <span class='text-muted font-weight-lighter'>
                                    {e.creator}
                                    <span class='text-muted px-2'>
                                        •
                                    </span>
                                    {localUtil.getTimeAgo(e.publishDate)}
                                </span>
                            </div>
                            <div class='d-flex flex-row align-items-center'>
                                &nbsp;
                                {/*
                                    Meny should be place here
                                */}
                            </div>
                        </>}
                        hideEmpty={isAdmin ? false : true}
                        // editElement={this.editElement}
                        editFunction={this.editArticle}
                        help={help || children}
                        showFilterBox={false}
                        maxHeight={maxHeight}
                        // imageContainerStyles={'aspect-ratio: 4 / 3'}
                        imageStyles={imageStyles}
                        // imageStyles={'aspect-ratio: 4 / 3'}
                        // showMenu={this.onClickMenu}
                        viewTags={this.viewTags}
                        // loadMore={articleStore.loadMore}

                        listWrapperClassnames={fullWidthOnly ? [] : []}
                        listContainerClassnames={fullWidthOnly ? [] : []}
                        listClasses={fullWidthOnly ? [] : []}
                        listStyles={[]}
                        listTitleStyles={fullWidthOnly ? [] : []}
                        listMaxImageWidth={fullWidthOnly ? [] : []}
                        listImageLocations={fullWidthOnly ? [] : []}
                        listWrapperClassNameFull={'w-100'}
                        checkContentHeight={checkContentHeight}
                        showFiles={showFiles}
                    >
                        {/* {isLoggedIn && (userOnly || showCreateButton) ? <>
                            <div class='d-flex flex-row'>
                                <button
                                    type='button'
                                    class={`btn ${buttonClass} rounded-pill`}
                                    data-category={category}
                                    onClick={this.onClickNewArticle}
                                >
                                    <i class='fa-solid fa-plus' /> {createButtonText ? createButtonText : <Text id='article-feed.add'>Add new</Text>}
                                </button>
                            </div>
                        </> : <></>} */}
                    </GuiListFrontpage>
                </div>
                {/* {productTotal > 0 && <>
                    <div class='d-flex flex-row w-100 justify-content-center'>
                        <small class='text-muted'>1 - {totalProducts} products</small>
                    </div>
                </>} */}

                {/* {dealers.length > 0 && (
                    <div>
                        <h2>Dealers</h2>
                        <ul>
                            {dealers.map(dealer => (
                                <li key={dealer.id}>{dealer.name}</li>
                            ))}
                        </ul>
                    </div>
                )} */}
            </div>
        </div>);
    }
}

export default FFEProducts;